import { t } from "@/lib/i18n";

export const STATUS_FLOW = ["new", "assigned", "received", "arrived_loading", "loaded", "departed", "arrived_unloading", "unloaded"];
export const DRIVER_STEPS = STATUS_FLOW.slice(2);

export const STATUS_COLORS = {
  new: "#64748B",
  assigned: "#3B82F6",
  received: "#60A5FA",
  arrived_loading: "#8B5CF6",
  loaded: "#F59E0B",
  departed: "#F97316",
  arrived_unloading: "#06B6D4",
  unloaded: "#10B981",
};

export const nextStep = (status) => {
  const i = STATUS_FLOW.indexOf(status);
  if (i < 2) return "received";
  return STATUS_FLOW[i + 1] || null;
};

export const mapsUrl = (address) => `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;
export const pointUrl = (lat, lng) => `https://www.google.com/maps?q=${lat},${lng}`;

export const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("ro-RO", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" }) : "";

const cityOf = (address = "") => {
  const parts = address.split(",").map((p) => p.trim()).filter(Boolean);
  if (parts.length >= 2) return parts[parts.length - 2].replace(/^\d{3,6}\s*/, "") || parts[0];
  return parts[0] || "—";
};

export const routeSummary = (stops = []) => {
  const load = stops.find((s) => s.type === "loading");
  const unload = [...stops].reverse().find((s) => s.type === "unloading");
  return `${cityOf(load?.address)} → ${cityOf(unload?.address)}`;
};

export const firstDate = (stops = []) => stops.find((s) => s.type === "loading")?.date || "";

export function getPosition() {
  return new Promise((resolve) => {
    if (!navigator.geolocation) return resolve(null);
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude }),
      () => resolve(null),
      { enableHighAccuracy: true, timeout: 8000, maximumAge: 60000 },
    );
  });
}

export async function compressImage(file, max = 2000, quality = 0.85) {
  if (!file.type.startsWith("image/")) return file;
  try {
    const bmp = await createImageBitmap(file);
    const scale = Math.min(1, max / Math.max(bmp.width, bmp.height));
    const canvas = document.createElement("canvas");
    canvas.width = Math.round(bmp.width * scale);
    canvas.height = Math.round(bmp.height * scale);
    canvas.getContext("2d").drawImage(bmp, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise((r) => canvas.toBlob(r, "image/jpeg", quality));
    if (!blob) return file;
    return new File([blob], file.name.replace(/\.\w+$/, "") + ".jpg", { type: "image/jpeg" });
  } catch {
    return file;
  }
}

export function buildWhatsAppUrl(order, driver) {
  const lang = driver.language || "ro";
  const lines = [`*${t(lang, "wa_title")}*`];
  if (order.reference) lines.push(`${t(lang, "reference")}: ${order.reference}`);
  order.stops.forEach((s, i) => {
    lines.push("");
    lines.push(`*${i + 1}. ${t(lang, s.type).toUpperCase()}*${s.date ? ` - ${s.date}` : ""}${s.time ? ` ${s.time}` : ""}`);
    if (s.company) lines.push(s.company);
    if (s.address) lines.push(s.address);
    if (s.reference) lines.push(`${t(lang, "reference")}: ${s.reference}`);
    if (s.address) lines.push(`${t(lang, "wa_maps")}: ${mapsUrl(s.address)}`);
  });
  const cargo = [order.cargo, order.weight, order.pallets && (/^\d+$/.test(order.pallets.trim()) ? `${order.pallets} ${t(lang, "pallets")}` : order.pallets)].filter(Boolean).join(" · ");
  if (cargo) lines.push("", `${t(lang, "cargo")}: ${cargo}`);
  if (order.driver_notes) lines.push(`${t(lang, "notes")}: ${order.driver_notes}`);
  lines.push("", t(lang, "wa_open"), `${window.location.origin}/driver/orders/${order.id}`);
  return `https://wa.me/${driver.phone}?text=${encodeURIComponent(lines.join("\n"))}`;
}
